export default __webpack_public_path__ + "static/media/DOMI.041f608a.png";